import { Navigate } from 'react-router';

/** What /app shows: both views start at their Dashboard. */
export function SignedInHome() {
  return <Navigate to="/app/dashboard" replace />;
}
